{"button":{"contactUs":"اتصل بنا","goHome":"انتقل إلى الصفحة الرئيسية","menu":"قائمة الموقع","order":"طلب"}}